import type { ReactNode } from 'react';
import { ActionLink } from '../../../parts/index.js';
import { addressOf } from './area-address.js';
import '../admin-master.css';

export function AdminFrame({ children }: { children: ReactNode }) {
  return <div className="admin-master ma-draw">{children}</div>;
}

/** Home owns its head; future area and person pages use the same head and back-link pattern. */
export function AdminHead({ title, back, children }: { title: string; back?: 'admin' | 'people'; children?: ReactNode }) {
  return <header className="admin-master-head">
    {back ? <ActionLink className="admin-master-back" href={back === 'admin' ? '/admin' : addressOf({ area: 'people' })}>
      {back === 'admin' ? 'Admin' : 'People and access'}
    </ActionLink> : null}
    <h1>{title}</h1>
    {children}
  </header>;
}
